import { BrowserRouter, Route, Routes } from "react-router-dom";

import { BreadcrumbProvider } from "components/breadcrumb/BreadcrumbProvider";
import AssetPage from "pages/content/assetPage/AssetPage";
import OurProjects from "pages/content/ourProjects/OurProjects";
import SearchPage from "pages/content/searchPage/SearchPage";
import ChangeAddressForm from "pages/content/user/ChangeAddressForm";
import ChangePasswordForm from "pages/content/user/ChangePasswordForm";
import CurrentOrders from "pages/content/user/CurrentOrders";
import UserFavoritePage from "pages/content/user/favoriteAndRate/UserFavoritePage";
import FinishedOrders from "pages/content/user/FinishedOrders";
import {
  ActionsPage,
  ArticleDetail,
  ArticlesCategoriesPage,
  BlogDetail,
  BlogPage,
  CartPage,
  CatalogPage,
  ContactPage,
  Dashboard,
  ErrorPage,
  HomePage,
  Login,
  Registration,
  UserDetail,
  VerifyPage,
} from "pages/index";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/index.js";
import AnalyticsTracker from "./AnalyticsTracker";
import CleanURL from "./CleanURL";
import ProtectedRoute from "./ProtectedRoute.js";

const AppRouter = () => {
  const theme = useSelector((state: RootState) => state.theme);
  const dispatch = useDispatch();

  useEffect(() => {
    // Dodaj klasu na <body> na osnovu trenutne teme
    document.body.className = theme === "dark" ? "dark-theme" : "";
  }, [theme]);

  // TODO 2 LANG
  // const DEFAULT_LANG = "en";
  // const SUPPORTED_LANGS = ["sr", "en"];

  // const useUrlLang = () => {
  //   // INFO: if `langMatch = null`, there was no match, meaning we're on a default-language route.
  //   const langMatch = useMatch(`/:lang(${SUPPORTED_LANGS.join("|")})`);

  //   const lang = langMatch?.params.lang ?? DEFAULT_LANG;
  //   const langUrlPrefix = lang === DEFAULT_LANG ? "" : `/${lang}`;
  //   const path = langMatch?.path ?? "/";

  //   return { lang, langUrlPrefix, path };
  // };
  //path={`/:lang(${SUPPORTED_LANGS.join("|")})/`}

  return (
    <BrowserRouter>
      {/* TODO PROVERITI UCITAVANJE */}
      <AnalyticsTracker />
      <BreadcrumbProvider>
        <CleanURL />

        <Routes>
          <Route path="/" element={<Dashboard />} errorElement={<ErrorPage />}>
            <Route index element={<HomePage />} errorElement={<ErrorPage />} />
            <Route
              path="/error"
              element={<ErrorPage />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/login"
              element={
                <ProtectedRoute valid_roles={[]} logged={false}>
                  <Login />
                </ProtectedRoute>
              }
            />
            <Route
              path="/registration"
              element={
                <ProtectedRoute valid_roles={[]} logged={false}>
                  <Registration />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verify"
              element={
                <ProtectedRoute valid_roles={[]} logged={false}>
                  <VerifyPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute
                  valid_roles={[
                    "ROLE_ADMIN",
                    "ROLE_CUSTOMER",
                    "ROLE_MODERATOR",
                    "ROLE_CONTENT_MODERATOR",
                  ]}
                  logged={true}
                >
                  <UserDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/change-password"
              element={
                <ProtectedRoute
                  valid_roles={[
                    "ROLE_ADMIN",
                    "ROLE_CUSTOMER",
                    "ROLE_MODERATOR",
                    "ROLE_CONTENT_MODERATOR",
                  ]}
                  logged={true}
                >
                  <ChangePasswordForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/change-address"
              element={
                <ProtectedRoute
                  valid_roles={[
                    "ROLE_ADMIN",
                    "ROLE_CUSTOMER",
                    "ROLE_MODERATOR",
                    "ROLE_CONTENT_MODERATOR",
                  ]}
                  logged={true}
                >
                  <ChangeAddressForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/favorite"
              element={
                <ProtectedRoute
                  valid_roles={[
                    "ROLE_ADMIN",
                    "ROLE_CUSTOMER",
                    "ROLE_MODERATOR",
                    "ROLE_CONTENT_MODERATOR",
                  ]}
                  logged={true}
                >
                  <UserFavoritePage />
                </ProtectedRoute>
              }
            />
            {/* TODO KADA BUDU TREBALI OCENJENI PROIZVODI */}
            {/* <Route
              path="/profile/rated"
              element={
                <ProtectedRoute
                  valid_roles={[
                    "ROLE_ADMIN",
                    "ROLE_CUSTOMER",
                    "ROLE_MODERATOR",
                    "ROLE_CONTENT_MODERATOR",
                  ]}
                  logged={true}
                >
                  <UserRatedPage />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/profile/finished-orders"
              element={
                <ProtectedRoute
                  valid_roles={[
                    "ROLE_ADMIN",
                    "ROLE_CUSTOMER",
                    "ROLE_MODERATOR",
                    "ROLE_CONTENT_MODERATOR",
                  ]}
                  logged={true}
                >
                  <FinishedOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/orders"
              element={
                <ProtectedRoute
                  valid_roles={[
                    "ROLE_ADMIN",
                    "ROLE_CUSTOMER",
                    "ROLE_MODERATOR",
                    "ROLE_CONTENT_MODERATOR",
                  ]}
                  logged={true}
                >
                  <CurrentOrders />
                </ProtectedRoute>
              }
            />

            {/* unutar cartPage treba ispitati rolu */}
            <Route path="/cart" element={<CartPage />} />
            {/* <Route path="/order" element={<OrderPage />} /> */}

            {/* unutar ove stranice ulogovani imaju neke privilegije */}
            <Route path="/articles" element={<ArticlesCategoriesPage />} />
            <Route
              path="/articles/:cat1"
              element={<ArticlesCategoriesPage />}
            />
            <Route
              path="/articles/:cat1/:cat2"
              element={<ArticlesCategoriesPage />}
            />
            <Route
              path="/articles/:cat1/:cat2/:cat3"
              element={<ArticlesCategoriesPage />}
            />

            <Route path="/article/:articleSlug" element={<ArticleDetail />} />
            <Route path="/search" element={<SearchPage />} />

            <Route path="/our-projects" element={<OurProjects />} />
            <Route path="/our-projects/:blog" element={<BlogDetail />} />
            {/* <Route path="/solar-panels/:blog" element={<BlogDetail />} /> */}

            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/blogs/:blog" element={<BlogDetail />} />

            <Route path="/actions" element={<ActionsPage />} />
            {/* info pages */}
            <Route
              path="/about"
              element={<AssetPage page="about" path="o_nama" />}
            />
            {/* partneri detaljno */}
            <Route path="/about/:blog" element={<BlogDetail />} />
            {/* na stranici about nalaze se partneri, pa je stranica /partners zakomentarisana */}
            {/* <Route path="/partners" element={<BlogPage />} /> */}
            {/* <Route path="/partners/:blog" element={<BlogDetail />} /> */}

            <Route path="/contact" element={<ContactPage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route
              path="/private-policy"
              element={
                <AssetPage page="private_policy" path="politika_privatnosti" />
              }
            />
            <Route
              path="/terms-and-conditions"
              element={
                <AssetPage page="terms_and_condition" path="uslovi_i_odredbe" />
              }
            />
            <Route
              path="/faq"
              element={<AssetPage page="faq" path="najcesca_pitanja" />}
            />

            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
      </BreadcrumbProvider>
    </BrowserRouter>
  );
};

export default AppRouter;
